module.exports = __webpack_public_path__ + "static/media/Document3.e6c93381.svg";